
















































































































import {defineComponent, getCurrentInstance, reactive, ref, watch, nextTick, computed} from '@vue/composition-api'
import useRootSetting from '@/hooks/useRootSetting'
import QuotationCompany from '@/views/createQuotation/quotationCompany.vue'
import Info from './info.vue'
import CompanyContacts from '@/components/Contacts/contacts.vue'
import request from "@/utils/request"
import {getToken} from '@/utils/auth'

export default defineComponent({
  name: 'CreateQuotation',
  components: {CompanyContacts, QuotationCompany, Info},
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: () => []
    }
  },
  setup(props, {emit}) {
    const form = reactive({
      kpzt: 0
    })
    const {getIsMobile} = useRootSetting()
    const instance = getCurrentInstance()
    const username = instance.proxy.$store.getters.name
    const showCompany = ref(false) //显示报价公司
    const showInfo = ref(false) //显示公司的信息
    const contactRef = ref(null)
    const infoRef = ref(null)
    const quotationDialog = ref<boolean>(false)

    const list = ref([]) //格式化列表数据
    const companyInfo = reactive({
      name: '',
      id: ''
    })
    const companyContact = ref([])

    //关闭报价公司弹窗
    const handleClose = () => {
      showCompany.value = false
      emit('handleCancel')
    }
    //动态计算型号表格的价格
    const calcPrice = (price, percent) => {
      const numPrice = Number(price)
      const numPercent = Number(percent)
      if (isNaN(numPrice)) return '0.00' // 价格为空时返回 0.00
      return (numPrice * (1 + numPercent)).toFixed(2)
    }

    //显示单价，新增的时候字段都可以编辑
    watch(() => props.data, (newData: any[]) => {
      list.value = (newData || []).map(row => ({
        ...row,
        price: Number(Number(row.price).toFixed(2)),// 初始显示原价
        editable: false
      }))
    }, {immediate: true})


    //打开报价公司弹窗
    const openCompany = () => {
      showCompany.value = true
    }

    //显示公司联系人
    const showCompanyContact = ref(false)
    const flag = ref(false)
    const getContact = async (showContact) => {
      if (showContact) {
        showCompanyContact.value = true
        if (showCompanyContact.value) {
          nextTick(() => {
            contactRef.value.getContract(companyInfo.id)
          })
        }
      }
    }
    const getCompany = ({company, cid}) => {
      showCompany.value = false
      showInfo.value = true
      companyInfo.id = cid
      companyInfo.name = company
      flag.value = true
      if (flag.value) {
        nextTick(() => {
          contactRef.value.getContract(companyInfo.id)
        })
      }
    }
    //选择联系人给所有字段赋值
    const allInfo = reactive({
      dsname: '',
      dsbumen: '',
      dstel: '',
      dsphone: '',
      dsmax: '',
      dsemail: ''
    })
    //多条或单条联系人选择完后数据填充
    const getSelectContacts = (val) => {
      const {name, phone, bumen, max, email, tel, cid} = val
      allInfo.dsname = name
      allInfo.dsbumen = bumen
      allInfo.dsphone = phone
      allInfo.dsemail = email
      allInfo.dstel = tel
      allInfo.dsmax = max
      showCompanyContact.value = false
    }

    //选完报价公司后获取联系人的第一条数据填充
    const getFirstContact = (data) => {
      //有时候联系人没有值，防止默认上选选择公司填充的值，强制清除
      if (data.length == 0) {
        Object.keys(allInfo).forEach(key => {
          allInfo[key] = "";
        });
      }
      const {name, phone, bumen, max, email, tel, cid} = data
      allInfo.dsname = name
      allInfo.dsbumen = bumen
      allInfo.dsphone = phone
      allInfo.dsemail = email
      allInfo.dstel = tel
      allInfo.dsmax = max
    }

    const handleCompanyContactClose = () => {
      showCompanyContact.value = false
    }

    //型号列表数量字段做验证
    const errors = ref({})
    const validateRow = (index, value) => {
      errors.value[index] = !value
    }

    //打印报价单
    const printQuotation = () => {
      let hasError = false
      errors.value = {} // 清空之前的错误状
      list.value.forEach((row, index) => {
        if (!row.num) {
          errors.value[index] = true
          hasError = true
        }
      })
      const newList = list.value.map(({ editable, ...rest }) => rest);
      const {bank,banknum,shuihao,...infoForm} = infoRef.value.form
      if (!hasError) {
        request({
          url: 'member_print_quo.yy',
          method: 'post',
          data: {
            username: username,
            ...infoForm,
            childdata:newList
          }
        }).then(res => {
          if (res.code == 200) {
            quotationDialog.value = false
            window.open(`${res.url}&token=${getToken()}`)
          }
        })
      }
    }
    //做一个变量标识，如果有了接受人，立马把flag改为false，防止多余的组件显示
    const handleFlag = (newFlag) => {
      flag.value = newFlag
    }

    // 添加联系人
    const addModel = () => {
      list.value.push({id: '', xhname: '', source: '', num: '', price: '', zprice: '', hq: '', bz: '', editable: true})
    }

    //计算所有行的总金额
    const totalAmount = computed(() => {
      return list.value.reduce((sum, row) => {
        const num = Number(row.num || 0);
        const price = Number(row.price || 0);
        return sum + num * price;
      }, 0).toFixed(2); // 保留两位小数
    });

    //报价单关闭及取消按钮
    const handleCloseQuotation = () => {
      emit('handleCancel')
    }

    //生成合同
    const printContract = () => {
      let hasError = false
      errors.value = {} // 清空之前的错误状
      list.value.forEach((row, index) => {
        if (!row.num) {
          errors.value[index] = true
          hasError = true
        }
      })
      const newList = list.value.map(({ editable, ...rest }) => rest);
      if (!hasError) {
        request({
          url: 'member_create_contract.yy',
          method: 'post',
          data: {
            username: username,
            cid: companyInfo.id,
            kpzt: form.kpzt,
            ...infoRef.value.form,
            childdata:newList
          }
        }).then(res => {
          if (res.code == 200) {
            quotationDialog.value = false
            window.open(`${res.url}&token=${getToken()}`)
          }
        })
      }
    }

    const handleDelete = (index:number) => {
      list.value.splice(index, 1)
    }
// 校验逻辑
    const numErrors = ref<{ [key: number]: boolean }>({})
    const validateNum = (row: { channel: number; num: string; number: string }, index: number) => {
      numErrors.value[index] = row.channel === 2 && Number(row.num) < Number(row.number);
    }
    watch(() => props.dialog, (val) => {
      quotationDialog.value = val
    }, {deep: true})

    return {
      numErrors,
      form,
      quotationDialog,
      totalAmount,
      flag,
      infoRef,
      username,
      errors,
      allInfo,
      showCompanyContact,
      companyContact,
      companyInfo,
      showInfo,
      showCompany,
      list,
      getIsMobile,
      contactRef,
      validateNum,
      handleDelete,
      printContract,
      handleCloseQuotation,
      addModel,
      handleFlag,
      handleCompanyContactClose,
      getFirstContact,
      getSelectContacts,
      getCompany,
      handleClose,
      calcPrice,
      openCompany,
      getContact,
      validateRow,
      printQuotation
    }
  }
})
